window.FA_QUIZ_FLOWS = window.FA_QUIZ_FLOWS || {};

window.FA_QUIZ_FLOWS['men-45'] = {
  id: 'men-45',
  klaviyoEvent: 'Men 45+ Quiz Completed',

  scoring: {
    map: {
      s1: [0, 1, 2, 3],
      s2: [0, 1],
      s3: [3, 2, 2, 2, 1],
      s4: [3, 0],
      s5: [3, 3, 2, 0],
      s6: [3, 2, 1, 2],
      s9: [0, 1, 2, 3],
      s10: [3, 2, 0, 0],
      s11: [3, 0, 1],
      s12: [0, 1, 2, 3]
    },
    tiers: [
      { id: 'high', min: 18 },
      { id: 'medium', min: 10 },
      { id: 'low', min: 0 }
    ],
    overrides: [
      { when: { s5: 3, s4: 1 }, force: 'low' },
      { when: { s1: 0, s9: 0 }, fromTier: 'high', toTier: 'medium' },
      { when: { s4: 0, s5: [0, 1] }, fromTier: 'low', toTier: 'medium' }
    ]
  },

  gauge: {
    title: 'Your Strength Score',
    scoreLabel: 'Your score:',
    labels: ['DEPLETED', 'LOW', 'NORMAL', 'OPTIMAL']
  },

  chart: {
    yLabels: ['Optimal', 'Normal', 'Low', 'Depleted'],
    xLabels: ['Now', '30 days', '60 days', '90 days'],
    calloutLabel: 'Your level'
  },

  steps: [
    {
      id: 'question_1',
      type: 'hero',
      title: "Find out why your strength isn't <br>what it was and how to get it back",
      sub: "This 2-minute assessment analyzes your strength, energy, and <br>muscle loss risk to find what's missing.",
      testimonial: { text: "I've started sending this to patients before their first visit. It asks the right questions for men over 45", initial: 'P', name: 'DR. PAREKH', badge: 'LONGEVITY EXPERT' },
      qLabel: 'How old are you?',
      q: 's1',
      options: ['45-49', '50-54', '55-64', '65 or older']
    },
    {
      id: 'question_2',
      type: 'question',
      title: 'What best describes you?',
      q: 's2',
      options: ['Female', 'Male'],
      helper: "After 45, men's muscle and recovery needs change fast. We tailor your results accordingly."
    },
    {
      id: 'question_3',
      type: 'question',
      title: "What's been bothering you most <br>lately?",
      q: 's3',
      options: ['Losing strength and muscle', 'The "dad bod" creeping in', 'Constant fatigue and low drive', 'Slower recovery after everything', 'Feeling older than I should']
    },
    {
      id: 'question_4',
      type: 'question',
      title: 'Do you feel weaker than you did five years ago, like lifts, yard work, or <br>stairs feel harder?',
      titleWide: true,
      q: 's4',
      options: ['Yes', 'No']
    },
    {
      id: 'question_5',
      type: 'question',
      title: 'How does your body look now <br>compared to your early 40s?',
      q: 's5',
      options: ['Softer - muscle turning into belly', 'Smaller and weaker at the same time', 'Similar, but less solid than before', 'Strong and lean - no complaints']
    },
    {
      id: 'question_6',
      type: 'question',
      title: 'When did you start noticing these <br>changes?',
      q: 's6',
      options: ['Over a year ago', 'In the past year', 'In the past few months', 'Honestly, it crept up slowly']
    },
    {
      id: 'question_7',
      type: 'question',
      title: 'What does your best self look like <br>in 90 days?',
      q: 's7',
      options: ['Get my strength back', 'Lose the gut, keep the muscle', 'Steady energy and sharper drive', 'Keep up with my kids or grandkids', 'All of the above']
    },
    {
      id: 'social_proof',
      type: 'interstitial',
      title: 'You are in the right place.',
      sub: 'Over 100,000+ men over 45 have rebuilt their strength, muscle and drive with the right supplement support.',
      cta: 'CONTINUE',
      testimonials: [
        { text: "I'm 54 and back to lifting what I did at 40. Thank to the quiz advices", initial: 'S', name: 'SEAN, 54', badge: 'Verified Review' },
        { text: 'My energy is back, I feel solid again, not soft. The quiz is best thing that happened to me, honestly.', initial: 'M', name: 'MAX, 49', badge: 'Verified Review' }
      ]
    },
    {
      id: 'question_8',
      type: 'question',
      title: 'How would you describe your <br>current body composition?',
      q: 's9',
      options: ['Lean and toned', 'Average build', 'Soft with some muscle', 'Out of shape / low muscle tone']
    },
    {
      id: 'question_9',
      type: 'question',
      title: 'How many hours of quality sleep <br>do you get per night?',
      q: 's10',
      options: ['Less than 5 hours', '5-6 hours', '7-8 hours', 'More than 8 hours']
    },
    {
      id: 'question_10',
      type: 'question',
      title: 'Do you struggle to eat enough <br>protein most days?',
      q: 's11',
      options: ['Yes', 'No', 'Not sure'],
      why: "After 45, men lose up to 1% of muscle per year as testosterone declines. Without enough protein and creatine, your body can't hold the muscle that keeps you strong and lean."
    },
    {
      id: 'analyzing',
      type: 'ring_loader',
      title: 'Analyzing your responses...',
      sub: 'Our algorithm is cross-referencing your answers with clinical data on men 45+ to find what your body is missing.',
      ringLabel: 'analyzes',
      duration: 4000
    },
    {
      id: 'question_11',
      type: 'question',
      title: 'How often do you eat red <br>meat or fish?',
      sub: '(These are the primary natural sources of creatine)',
      q: 's12',
      options: ['Daily - most meals include meat/fish', 'Several times a week', 'Occasionally - mostly plant-based', 'Rarely/never - vegetarian or vegan'],
      why: 'Red meat and fish are the primary dietary sources of creatine. Most men over 45 get far less than their muscles need - accelerating strength loss.'
    },
    {
      id: 'building_profile',
      type: 'step_loader',
      variant: 'counter',
      title: 'Building your profile...',
      sub: 'Personalizing your strength assessment',
      onDone: 'score',
      steps: [
        { num: 1, title: 'Analyzing symptoms', text: 'Cross-checking your reported symptoms' },
        { num: 2, title: 'Cross-referencing lifestyle factors', text: 'Diet, sleep, and activity patterns' },
        { num: 3, title: 'Calibrating supplement protocol', text: 'Matching to clinical benchmarks' },
        { num: 4, title: 'Personalizing your result', text: 'Generating your assessment...' }
      ]
    },
    {
      id: 'results',
      type: 'result_gauge',
      eyebrow: 'YOUR STRENGTH ASSESSMENT',
      title: 'Your Results Are In',
      meansTitle: 'What This Means For You',
      cta: "SHOW ME WHAT'S POSSIBLE"
    },
    {
      id: 'projection',
      type: 'result_chart',
      eyebrow: 'YOUR PROJECTED IMPROVEMENT',
      title: 'Strength Projection',
      sub: 'Based on your unique assessment profile',
      milestonesTitle: 'Expected Milestones',
      cta: 'SEE MY FULL PLAN'
    },
    {
      id: 'final_loader',
      type: 'step_loader',
      variant: 'ring',
      title: 'Finalizing your plan...',
      sub: 'Securing your personalized pricing',
      urgency: 'Your discount expires soon',
      onDone: 'redirect',
      steps: [
        { num: 1, title: 'Protocol calibrated', text: 'Your custom plan is ready' },
        { num: 2, title: 'Supply reserved', text: 'Stock allocated for your order' },
        { num: 3, title: 'Discount applied', text: '47% savings activated' },
        { num: 4, title: 'Generating your link', text: 'Creating secure checkout...' }
      ]
    }
  ],

  tiers: {
    high: {
      cls: 'fq-tier--high',
      levelLabel: 'CRITICALLY LOW',
      pct: '18%',
      activeSegment: 0,
      alertTitle: 'ACCELERATED STRENGTH LOSS',
      alertText: 'Your strength reserves are critically low for your age. Immediate creatine support strongly recommended.',
      statusValue: 'CRITICAL',
      statusSub: 'DEPLETED',
      riskValue: 'HIGH',
      riskSub: 'IMPACT',
      potential: '+60%',
      meansIntro: 'After 45, unsupported muscle loss compounds every year. This directly affects:',
      meansBullets: ['Strength and power for daily life', 'Muscle retention and size', 'Daily energy and drive', 'Metabolism and long-term health'],
      meansClosing: '<strong>Good news, this is fixable, and creatine is one of the most effective solutions for your situation. Tap below to see which brand is right for you.</strong>',
      chartStartY: 3,
      lift: '+60%',
      levelColor: '#FF0000',
      calloutBg: '#FFE1E1',
      potentialColor: '#FF0000',
      milestones: [
        { label: 'WEEK 1-2', title: 'Loading Phase', text: 'Daily creatine support starts refueling muscles that years of low creatine have drained.' },
        { label: 'WEEK 3-4', title: 'Activation Phase', text: 'Strength and energy climb. Lifts, stairs, and yard work start feeling easy again.' },
        { label: 'MONTH 2-3', title: 'Optimization Phase', text: 'Full saturation reached. Stronger and more energized than you\'ve felt in a decade.' }
      ]
    },
    medium: {
      cls: 'fq-tier--medium',
      levelLabel: 'DECLINING',
      pct: '52%',
      activeSegment: 1,
      alertTitle: 'STRENGTH DECLINING',
      alertText: 'Age-related strength loss is beginning to show. Proactive creatine support recommended.',
      statusValue: 'MILD',
      statusSub: 'DEPLETED',
      riskValue: 'MODERATE',
      riskSub: 'IMPACT',
      potential: '+30%',
      meansIntro: 'Your strength is starting to slip. You may be noticing:',
      meansBullets: ['Reduced energy throughout the day', 'Slower recovery after activity', 'Softer, less solid build', 'Gradual loss of muscle size'],
      meansClosing: '<strong>Good news, this is fixable, and creatine is one of the most effective solutions for your situation. Tap below to see which brand is right for you.</strong>',
      chartStartY: 2,
      lift: '+30%',
      levelColor: '#F19800',
      calloutBg: '#FFF3DF',
      potentialColor: '#3B7DDD',
      milestones: [
        { label: 'WEEK 1-2', title: 'Loading Phase', text: 'Daily creatine support begins restoring muscle fuel. Early strength and energy improvements.' },
        { label: 'WEEK 3-4', title: 'Stabilization', text: 'Steady improvement in strength, energy, and recovery.' },
        { label: 'MONTH 2-3', title: 'Optimization', text: 'Your strength stabilizes at a higher baseline. Full benefits realized.' }
      ]
    },
    low: {
      cls: 'fq-tier--low',
      levelLabel: 'NEARLY OPTIMAL',
      pct: '74%',
      activeSegment: 2,
      alertTitle: 'STRONG - ROOM TO OPTIMIZE',
      alertText: 'Your strength is holding up well - but not at full potential.',
      statusValue: 'GOOD',
      statusSub: 'DEPLETED',
      riskValue: 'LOW',
      riskSub: 'IMPACT',
      potential: '+20%',
      meansIntro: "You're doing well for your age, but there's still untapped potential:",
      meansBullets: ['Enhanced energy and stamina throughout the day', 'Faster recovery after training', 'A more solid, defined build', 'Better strength and performance as you age'],
      meansClosing: '<strong>Many people at your level unlock noticeably faster results with creatine. Tap below to see which brand is right for you.</strong>',
      chartStartY: 1,
      lift: '+20%',
      levelColor: '#338411',
      calloutBg: '#E8F8E0',
      potentialColor: '#3B7DDD',
      milestones: [
        { label: 'WEEK 1-2', title: 'Top-Off Phase', text: 'Daily creatine support tops off your muscle fuel. Subtle strength and energy gains.' },
        { label: 'WEEK 3-4', title: 'Enhancement', text: 'Consistent boost in daily energy, focus, and workout performance.' },
        { label: 'MONTH 2-3', title: 'Peak Performance', text: 'Your strongest decade yet - full muscle support achieved.' }
      ]
    }
  }
};
